module.exports = __webpack_public_path__ + "static/media/windy-variant.svg.8eac426d.png";